import React from 'react';

export const LoadingDots = () => (
	<div className="loading-dots">
		<div className="loading-dots--dot" />
		<div className="loading-dots--dot" />
		<div className="loading-dots--dot" />
	</div>
);
